<script setup lang="ts">
import { OptimizedUser } from '@/views/apps/centre-admin/types'
import UserProfile from '@/views/apps/centre-admin/user/UserProfile.vue'
import { useI18n } from 'vue-i18n'

// DAY-37: only for users whose roles allow it (same permission the API checks)
definePage({
  meta: {
    action: 'read',
    subject: 'Centers',
  },
})

const { error, success } = useSnackbar()
const { t } = useI18n()

const route = useRoute('apps-centre-admin-user-id')

const { data: userData } = await useApi<OptimizedUser>(`/Users/GetUser/${route.params.id}`)

const updateUser = async (updatedUserData: OptimizedUser) => {
  try {
    await $api(`/Users/UpdateUser/${route.params.id}`, {
      method: 'PUT',
      body: { ...updatedUserData },
    })
    success(t('User information updated successfully'))
    userData.value = { ...userData.value, ...updatedUserData }
  } catch (e) {
    error(t('Failed to update user information'))
    console.error('Error updating user info:', e)
  }
}
</script>

<template>
  <VRow v-if="userData">
    <VCol cols="12">
      <UserProfile :user-data="userData" @update-user="updateUser" />
    </VCol>
  </VRow>
  <div v-else>
    <VAlert type="error" variant="tonal"> User with ID {{ route.params.id }} not found! </VAlert>
  </div>
</template>
